"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBox = void 0;
var react_1 = __importDefault(require("react"));
var TextInput_1 = require("./TextInput");
var Button_1 = require("../buttons/Button");
var Group_1 = require("../layout/Group");
var SearchBox = function (props) {
    var _a = props.size, size = _a === void 0 ? 'block' : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, inputProps = __rest(props, ["size", "disabled"]);
    var items = [
        { element: react_1.default.createElement(TextInput_1.TextInput, __assign({}, inputProps, { disabled: disabled })), flex: 1 },
        { element: react_1.default.createElement(Button_1.Button, { label: react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: '<i class="fas fa-search"></i>' } }), onClick: props.onClick }) },
    ];
    return react_1.default.createElement(Group_1.Group, __assign({}, props, { items: items }));
};
exports.SearchBox = SearchBox;
//# sourceMappingURL=SearchBox.js.map